// DepartmentDropdown.js

import React, { useEffect, useState } from "react";
import { Form, Select } from 'antd';
import DepartmentsApi from '../Apis/DepartmentsApi';
import {
    ReloadOutlined,
    SyncOutlined,
} from "@ant-design/icons";
import { Link } from "react-router-dom";
import StorageListApi from "../Apis/StorageListApi";

const StorageDropDown = ({ onStorageResponse }) => {

    const [Storages2, setStorages2] = React.useState([]);
    const [loading, setLoading] = useState(false);
    const [TotalPageNew, setTotalPageNew] = useState(null);
    const [page, setPage] = useState(0);

    const [IsReloadStorageClicked, setIsReloadStorageClicked] =
        useState(false);

    const handleReloadStorageClick = async () => {
        setIsReloadStorageClicked(true);
        try {
            setLoading(true);

            let currentPage = 0;
            let totalPages = 1;
            let allDrops = [];

            do {
                const response = await StorageListApi?.ListStorage(currentPage,10);
                totalPages = response?.totalPages;
                allDrops = [...allDrops, ...(response?.payloadDto || [])];
                currentPage++;

        } while( currentPage < totalPages);
            setTotalPageNew(totalPages);
            setPage(currentPage);
            setStorages2(allDrops);
    } catch (error) {
            console.error("Error fetching Storage Dropdowns", error)
    }finally {
        setLoading(false);
        
        setTimeout(() => {
            setIsReloadStorageClicked(false);
            }, 1000);
        }
    };

    const fetchStorageDrops = async () => {
        try {
            setLoading(true);

            let currentPage = 0;
            let totalPages = 1;
            let allDrops = [];

            do {
                const response = await StorageListApi?.ListStorage(currentPage,10);
                totalPages = response?.totalPages;
                allDrops = [...allDrops, ...(response?.payloadDto || [])];
                currentPage++;
                
        } while( currentPage < totalPages);

            setTotalPageNew(totalPages);
            setPage(currentPage);
            setStorages2(allDrops);

        } catch (error) {
            console.error('Error fetching Storage Dropdowns:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleChangeProduct = (value) => {

        StorageListApi.Singlestorage(value).then((response) => {
            onStorageResponse(response.payload);

        })
            .catch((err) => {
                console.log(err);
            });
    };

    useEffect(() => {
        fetchStorageDrops();
    }, []);

    return (
        <><div className="row product-row d-flex ">
            <Form.Item
                name="StorageID"
                label="Storages :"
                className="text-lable col-10"
                rules={[
                    {
                        required: true,
                        message: "Please Select Storage.",
                    },
                ]}
            >
                <Select
                    className="control-Select mb-1"
                    placeholder="Select Storage"
                    onChange={(value) => handleChangeProduct(value)}
                >
                    {Storages2.filter(
                        (option) =>
                            !(option.temperatureMinInCelsius === 0 &&
                                option.temperatureMaxInCelsius === 0)
                    )
                        .map((option) => (
                            <Select.Option key={option.id} value={option.id}>
                                {option.name} ({option.temperatureMinInCelsius} - {option.temperatureMaxInCelsius} °C)
                            </Select.Option>
                        ))}
                    {loading && (
                        <Select.Option disabled key="loading" value="loading">
                            Loading...
                        </Select.Option>
                    )}
                </Select>
            </Form.Item>
            <div className=" col-2">
                {IsReloadStorageClicked ? (
                    <div className="refresh-btn">
                        <SyncOutlined spin className="px-2" />
                    </div>
                ) : (
                    <div
                        className="refresh-btn"
                        onClick={handleReloadStorageClick}
                        style={{ cursor: "pointer" }}
                    >
                        <ReloadOutlined className="px-2" />
                    </div>
                )}
            </div>
        </div>
            <div className="row pb-2 ">
                <div className="col-4"></div>
                <div className="col-6">
                    <Link to={"/masters/storage/add-storage"} target="_blank">
                        <u>Create New Storage</u>
                    </Link>
                </div>
            </div>
        </>

    );
};

export default StorageDropDown;
